import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthenticationService } from '../auth/authentication.service';
import { Refund, RefundRequest } from '../../models/refund.model';

/** Client for the refund endpoints under /api/admin/payments (request → approve → process | reject). */
@Injectable({ providedIn: 'root' })
export class RefundService {
  private readonly baseUrl = `${environment.apiUrl}/api/admin/payments`;

  constructor(private http: HttpClient, private auth: AuthenticationService) {}

  /** The backend stamps requested/approved/processed-by from these headers. */
  private userHeaders(): HttpHeaders {
    const u = this.auth.getCurrentUser();
    let h = new HttpHeaders();
    if (u?.id) h = h.set('X-User-Id', String(u.id));
    if (u?.username) h = h.set('X-User-Name', u.username);
    return h;
  }

  listForPayment(paymentId: number): Observable<Refund[]> {
    return this.http.get<Refund[]>(`${this.baseUrl}/${paymentId}/refunds`);
  }

  request(paymentId: number, body: RefundRequest): Observable<Refund> {
    return this.http.post<Refund>(`${this.baseUrl}/${paymentId}/refund`, body, { headers: this.userHeaders() });
  }

  approve(refundId: number): Observable<Refund> {
    return this.http.post<Refund>(`${this.baseUrl}/refunds/${refundId}/approve`, {}, { headers: this.userHeaders() });
  }

  process(refundId: number): Observable<Refund> {
    return this.http.post<Refund>(`${this.baseUrl}/refunds/${refundId}/process`, {}, { headers: this.userHeaders() });
  }

  reject(refundId: number, reason: string): Observable<Refund> {
    const params = new HttpParams().set('reason', reason);
    return this.http.post<Refund>(`${this.baseUrl}/refunds/${refundId}/reject`, {}, { params, headers: this.userHeaders() });
  }
}
